import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { unescapeHTML, titleize } from 'underscore.string';
import { NavLink } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import CargomaticLogo from 'img/cargomatic-logo-dark.png';
import SessionStore from 'stores/SessionStore';
import classNames from 'classnames';
import Navbar from 'components/v2/navs/Navbar';
import UserActionCreators from 'actions/UserActionCreators';
import { Avatar } from 'components/modules/user/Avatar';
import LanguageSelector from 'components/site/language-selector';
import DropdownMenu from 'components/v2/dropdowns/DropdownMenu';
const activeStyle = {
    fontWeight: 'bold',
    color: 'white',
};
function logout() {
    UserActionCreators.logout();
}
export default function WarehouseNavigation() {
    const { t } = useTranslation();
    function renderMobileNav(onClose) {
        return [
            React.createElement(NavLink, { className: "nav-item", to: "/warehouse/user/profile", onClick: onClose, key: "mobile-profile" },
                React.createElement("span", null, titleize(t('PROFILE', { count: 1 })))),
            React.createElement("a", { href: "#", className: "nav-item", onClick: logout, key: "mobile-signout" }, t('SIGN_OUT')),
        ];
    }
    function renderRightNav() {
        const name = SessionStore.getUser().name;
        const userId = SessionStore.getUser()._id;
        let profileButton = null;
        profileButton = (React.createElement("div", { key: "profile-button", "data-testid": "profile-button", title: unescapeHTML(name), className: "flex text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-gray-800 focus:ring-white", "aria-haspopup": "true" },
            React.createElement(Avatar, { key: userId, userId: userId, altName: "Logo", className: "w-8 h-8 rounded-full" })));
        return [
            React.createElement("div", { key: "language-selector", "data-testid": "warhouse-nav-language-selector", className: classNames('flex items-center justify-center nav-item mr-2', { hidden: LANGUAGE_SELECTION_DISABLED }) },
                React.createElement(LanguageSelector, null)),
            React.createElement(DropdownMenu, { title: "WarehouseUser Center", button: profileButton, isDark: true, key: "main-dropdown" },
                React.createElement(Menu.Item, { key: "profile" },
                    React.createElement(NavLink, { activeClassName: "active-light", className: "nav-item", to: "/warehouse/user/profile" },
                        React.createElement("span", null, titleize(t('PROFILE', { count: 1 }))))),
                React.createElement(Menu.Item, { key: "sign-out" },
                    React.createElement("a", { href: "#", className: "nav-item", onClick: logout }, t('SIGN_OUT')))),
        ];
    }
    const brandLogo = (React.createElement(NavLink, { to: "/", key: "brand-logo" },
        React.createElement("img", { alt: "Cargomatic", src: CargomaticLogo, style: { height: 25 } })));
    return (React.createElement(Navbar, { logo: brandLogo, renderRightNav: renderRightNav, renderMobileNav: renderMobileNav }));
}
